//@flow
import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  POLL_GET_REQUESTING,
  POLL_GET_SUCCESS,
  POLL_GET_ERROR,
  POLL_ANSWER,
} from "./constants";

import { fetchApi } from "../api";

const endPoints = {
  answerPoll: "/v1/polls/answer",
  getPoll: "/v1/polls/", // pollId
};

const getPollApi = payload => {
  return fetchApi(`${endPoints.getPoll}${payload}`, {}, "get");
};

const answerPollApi = payload => {
  return fetchApi(`${endPoints.answerPoll}`, payload, "patch");
};

function* getPollFlow(action) {
  try {
    const success = yield call(getPollApi, action.payload);
    yield put({ type: POLL_GET_SUCCESS, payload: success });
  } catch (error) {
    console.log(error);
    yield put({ type: POLL_GET_ERROR, payload: error });
  }
}

function* answerPollFlow(action) {
  try {
    const success = yield call(answerPollApi, action.payload);
  } catch (error) {
    console.log(error);
  }
}

function* notificationsWatcher() {
  yield all([
    takeLatest(POLL_GET_REQUESTING, getPollFlow),
    takeLatest(POLL_ANSWER, answerPollFlow),
  ]);
}

export default notificationsWatcher;
